
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function VisionFuture() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Future Vision */}
        <div className="text-center mb-20">
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold mb-4">
            FUTURE VISION
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            未来への展望
          </h2>
          <div className="w-16 h-1 bg-blue-600 rounded-full mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            私たちは常に未来を見据え、お客様と地域社会により大きな価値を提供し続けます
          </p>
        </div>

        {/* Vision Goals */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/8a51d88b0a9439849fe1610e03319394.jpg"
              alt="未来への展望"
              className="w-full rounded-2xl shadow-2xl object-cover object-top"
            />
          </div>

          <div className="space-y-8">
            <div className="bg-gradient-to-r from-blue-50 to-white p-8 rounded-2xl border-l-4 border-blue-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                デジタル変革の推進
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                最新のデジタル技術を活用し、建物の設計から維持管理まで、すべての工程でより効率的で透明性の高いサービスを提供します。
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>3D建築モデリングとVR技術の活用</span>
                </li>
                <li className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>IoTセンサーによる予防保全システム</span>
                </li>
                <li className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>AIを活用した最適な施工計画</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-white p-8 rounded-2xl border-l-4 border-green-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                持続可能な建物づくり
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                環境負荷を最小限に抑えながら、建物の長寿命化を実現し、次世代に美しい環境を残すことに貢献します。
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <span>省エネルギー設計とリノベーション</span>
                </li>
                <li className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <span>再生可能エネルギーの積極的活用</span>
                </li>
                <li className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <span>環境に優しい建材の選定と使用</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Growth Roadmap */}
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-12 mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">成長ロードマップ</h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              段階的な成長戦略により、持続可能な発展を目指します
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                1
              </div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 mt-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-building-line text-blue-600 text-2xl"></i>
                </div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">基盤強化</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                現在の事業領域での品質向上とお客様満足度の更なる向上を図ります。地域での信頼基盤をより一層強固にします。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                2
              </div>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 mt-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-rocket-line text-green-600 text-2xl"></i>
                </div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">事業拡大</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                新しい技術の導入とサービス領域の拡大により、より多くのお客様のニーズにお応えできる体制を構築します。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                3
              </div>
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 mt-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-global-line text-purple-600 text-2xl"></i>
                </div>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">価値創造</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                業界のリーディングカンパニーとして、新しい価値とソリューションを創造し、社会に貢献します。
              </p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div 
          className="relative rounded-3xl overflow-hidden p-16 text-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Handshake%20between%20business%20partners%20in%20professional%20office%20environment%20with%20warm%20golden%20lighting%2C%20representing%20trust%20and%20partnership%20in%20construction%20and%20facility%20management%20industry%2C%20modern%20corporate%20setting%20with%20large%20windows%20showing%20city%20skyline%2C%20symbolizing%20successful%20business%20relationships%20and%20future%20collaboration%20opportunities&width=1200&height=600&seq=cta-partnership&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-blue-600/70"></div>
          <div className="relative">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              一緒に未来を創造しませんか？
            </h3>
            <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
              私たちの理念に共感していただき、共に成長できるパートナーやお客様との出会いを大切にしています。
              共に未来を創っていませんか？まずはご連絡ください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/contact">
                <Button size="lg" className="bg-green-600 text-white hover:bg-green-700 border-2 border-green-600 shadow-lg">
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-mail-line"></i>
                  </div>
                  お問い合わせ
                </Button>
              </Link>
              <Link to="/services">
                <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-600">
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-service-line"></i>
                  </div>
                  事業内容を見る
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
